import { __ } from '@wordpress/i18n';
import { registerPaymentMethod, registerExpressPaymentMethod } from '@woocommerce/blocks-registry';
import { getSetting } from '@woocommerce/settings';
import { useEffect } from '@wordpress/element'
import {
    handle_paysafe_js_setup_error,
    get_paysafe_label,
    handle_express_payment_click,
    set_log_nonce,
    main_paysafe_checkout_success_handler,
    resolve_paysafe_payment_description,
    get_paysafe_express_label,
    resolve_paysafe_express_payment_description,
    init_paysafe_fields
} from "./paysafe-common";

const paymentMethodId = "apple_pay";
const settings = getSetting( 'apple_pay_data', {} );
set_log_nonce(settings.nonce);
const settingsGooglePay = getSetting( 'google_pay_data', {} );
const is_hosted_integration = settings.integration_type === 'paysafe_js';

let saveListenerControllerGooglePay, saveListenerControllerApplePay;

let is_apple_pay_google_pay_combo_activated = false;
if (!!settings.is_apple_pay_express_enabled && !!settings.is_google_pay_express_enabled) {
    is_apple_pay_google_pay_combo_activated = true;
}

let current_cart_data = {};
let is_express_apple_pay_initialized = false;
const init_apple_pay_hosted_integration = function(onClick, onClose, onError) {
    // if the page doesn't have the form, don't load it
    if (!jQuery('#paysafe-hosted-apple-pay-payment-form').length) {
        return;
    }

    if (is_express_apple_pay_initialized) {
        return;
    }

    if (typeof(paysafe) === "undefined" || typeof(paysafe.fields) === "undefined") {
        setTimeout(function() {
            init_apple_pay_hosted_integration(onClick, onClose, onError);
        }, 1000);
        return;
    }

    is_express_apple_pay_initialized = true;
    const paysafeOptions = {
        // You must provide currencyCode to the Paysafe JS SDK to enable the Payment API integration
        currencyCode: settings.currency_code,

        // select the Paysafe test / sandbox environment
        environment: settings.test_mode ? 'TEST' : 'LIVE',

        transactionSource: 'WooCommerceJs',

        accounts: {
            default: settings.account_id,
            applePay: settings.account_id,
        },

        fields: {
            applePay: {
                selector: '#paysafe-apple-pay',
                type: 'buy',
                label: __('Pay with Apple Pay', 'paysafe-checkout'),
                color: 'black',

                buttonWidth: '240px',
                buttonHeight: '55px',
            },
        },
    };
    if (settings.initialization_timeout != null && Number(settings.initialization_timeout) >= 1000) {
        paysafeOptions.initializationTimeout = Number(settings.initialization_timeout);
    }
    if (settings.apple_pay_issuer_country) {
        paysafeOptions.fields.applePay.country = settings.apple_pay_issuer_country;
    }

    if (is_apple_pay_google_pay_combo_activated) {
        paysafeOptions.accounts.googlePay = settingsGooglePay.account_id;

        paysafeOptions.fields.googlePay = {
            selector: '#paysafe-google-pay',
            type: 'buy',
            color: 'black',
            label: __('Google Pay', 'paysafe-checkout'),

            buttonWidth: '240px',
            buttonHeight: '55px',
        };
        if (settingsGooglePay.google_pay_issuer_country) {
            paysafeOptions.fields.googlePay.country = settingsGooglePay.google_pay_issuer_country;
        }
        if (settingsGooglePay.google_pay_merchant_id) {
            paysafeOptions.fields.googlePay.merchantId = settingsGooglePay.google_pay_merchant_id;
        }
    }

    let button_clicked = false;

    // initialize the hosted iframes using the SDK setup function
    init_paysafe_fields(settings, paysafeOptions, current_cart_data, true)
        .then( instance => {
            saveListenerControllerApplePay?.abort();
            saveListenerControllerApplePay = new AbortController();

            document.getElementById('paysafe-apple-pay').addEventListener(
                'click',
                function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    onClick();
                    button_clicked = true;

                    handle_express_payment_click(
                        'APPLEPAY',
                        settings,
                        current_cart_data,
                        instance,
                        onError,
                        onClose
                    );
                },
                { signal: saveListenerControllerApplePay.signal },
            );

            if (is_apple_pay_google_pay_combo_activated) {
                saveListenerControllerGooglePay?.abort();
                saveListenerControllerGooglePay = new AbortController();

                document.getElementById('paysafe-google-pay').addEventListener(
                    'click',
                    function (event) {

                        event.preventDefault();
                        event.stopPropagation();

                        // disable the express checkout block,
                        // payment process started
                        onClick();
                        button_clicked = true;

                        handle_express_payment_click(
                            'GOOGLEPAY',
                            settingsGooglePay,
                            current_cart_data,
                            instance,
                            onError,
                            onClose
                        );
                    },
                    { signal: saveListenerControllerGooglePay.signal },
                );
            }
        })
        .catch(error => {
            handle_paysafe_js_setup_error(
                error,
                settings,
                paysafeOptions,
                current_cart_data,
                button_clicked,
                onError,
                onClose
            );
            button_clicked = false;
        });
}

const Content = ( props ) => {
    const { eventRegistration, emitResponse } = props;
    const { onCheckoutSuccess } = eventRegistration;

    useEffect(() => {
        const unsubscribe = onCheckoutSuccess( (response) => {
            const payment_method_details = {
                applePay: {
                    accountId: settings.account_id,
                    label: 'apple_pay',
                }
            };
            if (settings.apple_pay_issuer_country) {
                payment_method_details.applePay.country = settings.apple_pay_issuer_country;
            }

            return main_paysafe_checkout_success_handler(
                response,
                current_cart_data,
                settings,
                {
                    displayPaymentMethods: [
                        'applePay'
                    ],
                    paymentMethodDetails: payment_method_details,
                    settings: {
                        add_customer_when_single_use_token: true,
                        add_billing_when_single_use_token: true,
                    }
                }, false, emitResponse);
        });

        return () => {
            unsubscribe();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        '',
        [],
        onCheckoutSuccess,
    ]);

    return resolve_paysafe_payment_description(settings);
};

const ExpressContent = ( props ) => {
    const { eventRegistration, onClick, onClose, onError } = props;
    const { onCheckoutSuccess } = eventRegistration;

    const { subscribe, select } = window.wp.data;
    const { checkoutStore } = window.wc.wcBlocksData;

    let wasCalculating = select( checkoutStore ).isCalculating();

    useEffect(() => {
        const unsubscribe = subscribe( () => {
            const isCalculating = select( checkoutStore ).isCalculating();

            if ( isCalculating === wasCalculating ) {
                return;
            }

            is_express_apple_pay_initialized = !!isCalculating;

            wasCalculating = isCalculating;
        });
    }, [
        [],
        {},
        subscribe,
    ]);

    useEffect(() => {
        init_apple_pay_hosted_integration(onClick, onClose, onError);

        const unsubscribe = onCheckoutSuccess( (response) => {
            return response;
        });

        return () => {
            unsubscribe();
        };
    }, [
        [],
        {},
        onCheckoutSuccess,
    ]);

    return resolve_paysafe_express_payment_description(
        settings,
        wp.element.RawHTML({ children: settings.integration_hosted_form })
    );
};
async function isApplePayAvailable() {
  // Safari-specific check
  if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
    return true;
  }

  // Cross-browser check via Payment Request API (Chrome, Edge, etc.)
  if (window.PaymentRequest) {
    try {
      const request = new PaymentRequest(
        [{ supportedMethods: "https://apple.com/apple-pay", data: { version: 3, merchantIdentifier: "your.merchant.id", merchantCapabilities: ["supports3DS"], supportedNetworks: ["visa", "masterCard", "amex"], countryCode: "US" } }],
        { total: { label: "Check", amount: { currency: "USD", value: "0.00" } } }
      );
      return await request.canMakePayment();
    } catch (e) {
      return false;
    }
  }

  return false;
}

if (isApplePayAvailable) {
    if (!is_hosted_integration) {
        const PaysafeApplePayPayments = {
            name: paymentMethodId,
            paymentMethodId: paymentMethodId,
            label: get_paysafe_label(settings.title, settings.icon),
            content: <Content/>,
            edit: <Content/>,
            canMakePayment: (cartData => {
                current_cart_data = cartData;

                return true;
            }),
            ariaLabel: __('Paysafe Checkout', 'paysafe-checkout'),
            supports: {
                features: settings.supports,
            },
        };
        registerPaymentMethod(PaysafeApplePayPayments);
    } else {
        const PaysafeApplePayExpressPayment = {
            name: paymentMethodId,
            title: 'Apple Pay Express Checkout',
            description: settings.description,
            gatewayId: 'paysafe',
            label: get_paysafe_express_label(),
            content: <ExpressContent/>,
            edit: <ExpressContent/>,
            canMakePayment: (cartData => {
                current_cart_data = cartData;

                return true;
            }),
            paymentMethodId: paymentMethodId,
            supports: {
                features: settings.supports,
            },
        };

        registerExpressPaymentMethod(PaysafeApplePayExpressPayment);
    }
}
